import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
export type TeamFragment = { __typename?: 'Team', id: number, label: string, constantName: string, region: Types.RegionEnum, teamType?: string | null, recursiveParents: Array<{ __typename?: 'Team', id: number, constantName: string, label: string }>, parentTeam?: { __typename?: 'Team', id: number, constantName: string, label: string } | null };

export const TeamFragmentDoc = gql`
    fragment team on Team {
  id
  label
  constantName
  region
  recursiveParents {
    id
    constantName
    label
  }
  parentTeam {
    id
    constantName
    label
  }
  teamType
}
    `;